import { Action } from '../types/reducer/Action';
import { State } from '../types/reducer/State';
import { addView } from './actions/addView';
import { resetViewPeriod } from './actions/resetViewPeriod';
import { setViewPeriod } from './actions/setViewPeriod';
import { updateView } from './actions/updateView';
import { setViewAgent } from './actions/setViewAgent';
import { setPanelSize } from './actions/setPanelSize';
import { setSideBarPosition } from './actions/setSideBarPosition';

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'RESET_VIEW_PERIOD':
      return resetViewPeriod(state);
    case 'ADD_VIEW':
      return addView(state, action.payload);
    case 'UPDATE_VIEW':
      return updateView(state, action.payload);
    case 'SET_VIEW_PERIOD':
      return setViewPeriod(state, action.payload);
    case 'SET_VIEW_AGENT':
      return setViewAgent(state, action.payload);
    case 'SET_SIDEBAR_POSITION':
      return setSideBarPosition(state, action.payload);
    case 'SET_PANEL_SIZE':
      return setPanelSize(state, action.payload);
  }
}
